<template>
  <div class="resource-page">
    <div class="features f-r-vc">
      <el-button
        type="primary"
        class="feature-button depp-green-bg"
        @click="openResourceDialog(null)"
      >
        <svg-icon icon-class="plus" class="svg-white-color" />
        Create Resource
      </el-button>
    </div>
    <div class="resource-list">
      <searchable-table
        :table-headers="ResourceTableHeaders"
        :table-data="resourceList"
        :search-params="searchForm"
        :search-param-change="searchParamChange"
        :has-actions="true"
      >
        <template v-slot:actions="props">
          <el-button
            size="small"
            type="text"
            @click="openResourceDialog(props.row)"
          >
            Edit
          </el-button>
          <el-button
            size="small"
            type="text"
            @click="deleteResource(props.row)"
          >
            Delete
          </el-button>
        </template>
      </searchable-table>
    </div>
    <dialog-edit-or-create
      ref="resourceEdit"
      :formInputInit="InitResourceForm"
    />
  </div>
</template>
<script>
import set from 'lodash/set'
import cloneDeep from 'lodash/cloneDeep'
// msg
// import PagesMessage from '@/core/message/pages'
// apis
import {
  createResource,
  updateResource,
  queryResource,
  removeResource
} from '@/api/resource'
// models
import {
  ResourceTableHeaders,
  ResourceSearchForm,
  InitResourceForm,
  ResourceSearchParamsWrapUp
} from '@/core/models/resource'
// components
import DialogEditOrCreate from '@/components/common/DialogEditOrCreate.vue'
import SearchableTable from '@/components/common/SearchableTable.vue'
export default {
  name: 'ResourceView',
  components: {
    SearchableTable,
    DialogEditOrCreate
  },
  data() {
    return {
      ResourceTableHeaders,
      ResourceSearchForm,
      loadingResource: false,
      resourceList: {},
      searchForm: cloneDeep(ResourceSearchForm)
    }
  },
  mounted() {
    this.doResourceSearch()
  },
  methods: {
    createResourceCb(data) {
      createResource(data).then(res => {
        if (res) {
          this.$message.success('Create resource successfully!')
          this.doResourceSearch()
        }
      })
    },
    updateResourceCb(data) {
      updateResource(data).then(res => {
        if (res) {
          this.$message.success('Update resource successfully!')
          this.doResourceSearch()
        }
      })
    },
    deleteResource(data) {
      this.$confirm(`Delete resource ${data.name}, continue?`, 'Confirm', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          removeResource(data.id).then(res => {
            if (res) {
              this.$message.success('Delete successfully!!')
              this.doResourceSearch()
            }
          })
        })
        .catch(() => {})
    },
    InitResourceForm,
    openResourceDialog(data) {
      this.$refs.resourceEdit.open(
        data,
        data ? this.updateResourceCb : this.createResourceCb
      )
    },
    searchParamChange(key, path, value) {
      set(this.searchForm[key], path, value)
      this.doResourceSearch()
    },
    doResourceSearch() {
      const params = ResourceSearchParamsWrapUp(this.searchForm)
      queryResource(params).then(res => {
        this.resourceList = res
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.resource-page {
  width: 100%;
  overflow-x: hidden;

  .features {
    @extend .global-margin;
  }

  @extend .f-c;

  .resource-list {
    @extend .global-margin;
    @extend .shadow-level-three;

    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;
  }
}
</style>
